 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import HISTORYMAYBEWRITTENBYTHEVICTORSBUTITISNOTALWAYSWRITTENINSTONE from '@/components/history-may-be-written-by-the-victors-but-it-is-not-always-written-in-stone'
 import TITLEPAGE from '@/components/title-page'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import CONTENTS from '@/components/contents'
 import CHAPTER001 from '@/components/chapter-001'
 import ABOUTTHEAUTHOR from '@/components/about-the-author'
 import CHAPTER002 from '@/components/chapter-002'
 import ABOUTTHEAUTHOR2 from '@/components/about-the-author-2'
 import CHAPTER003 from '@/components/chapter-003'
 import ABOUTTHEAUTHORS from '@/components/about-the-authors'
 import CHAPTER004 from '@/components/chapter-004'
 import ABOUTTHEAUTHOR3 from '@/components/about-the-author-3'
 import CHAPTER005 from '@/components/chapter-005'
 import ABOUTTHEAUTHOR4 from '@/components/about-the-author-4'
 import CHAPTER006 from '@/components/chapter-006'
 import ABOUTTHEAUTHOR5 from '@/components/about-the-author-5'
 import CHAPTER007 from '@/components/chapter-007'
 import ABOUTTHEAUTHOR6 from '@/components/about-the-author-6'
 import CHAPTER008 from '@/components/chapter-008'
 import ABOUTTHEAUTHOR7 from '@/components/about-the-author-7'
 import CHAPTER009 from '@/components/chapter-009'
 import ABOUTTHEAUTHOR8 from '@/components/about-the-author-8'
 import CHAPTER010 from '@/components/chapter-010'
 import ABOUTTHEAUTHOR9 from '@/components/about-the-author-9'
 import CHAPTER011 from '@/components/chapter-011'
 import ABOUTTHEAUTHOR10 from '@/components/about-the-author-10'
 import CHAPTER012 from '@/components/chapter-012'
 import ABOUTTHEAUTHOR11 from '@/components/about-the-author-11'
 import CHAPTER013 from '@/components/chapter-013'
 import ABOUTTHEAUTHOR12 from '@/components/about-the-author-12'
 import CHAPTER014 from '@/components/chapter-014'
 import ABOUTTHEAUTHOR13 from '@/components/about-the-author-13'
 import CHAPTER015 from '@/components/chapter-015'
 import ABOUTTHEAUTHOR14 from '@/components/about-the-author-14'
 import CHAPTER016 from '@/components/chapter-016'
 import ABOUTTHEAUTHOR15 from '@/components/about-the-author-15'
 import CHAPTER017 from '@/components/chapter-017'
 import ABOUTTHEAUTHOR16 from '@/components/about-the-author-16'
 import CHAPTER018 from '@/components/chapter-018'
 import ABOUTTHEAUTHOR17 from '@/components/about-the-author-17'
 import CHAPTER019 from '@/components/chapter-019'
 import ABOUTTHEAUTHOR18 from '@/components/about-the-author-18'
 import CHAPTER020 from '@/components/chapter-020'
 import ABOUTTHEAUTHOR19 from '@/components/about-the-author-19'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT2 from '@/components/copyright-2'
 import ABOUTTHEEDITOR from '@/components/about-the-editor'
 import IFYOULIKED from '@/components/if-you-liked'
 import OTHERWORDFIREPRESSTITLESEDITEDBYLISAMANGUM from '@/components/other-wordfire-press-titles-edited-by-lisa-mangum'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/chapter-001",
 			"name" : "chapter-001",
 			"component" : CHAPTER001
 		},
 		{
 			"path" : "/about-the-author",
 			"name" : "about-the-author",
 			"component" : ABOUTTHEAUTHOR
 		},
 		{
 			"path" : "/chapter-002",
 			"name" : "chapter-002",
 			"component" : CHAPTER002
 		},
 		{
 			"path" : "/about-the-author-2",
 			"name" : "about-the-author-2",
 			"component" : ABOUTTHEAUTHOR2
 		},
 		{
 			"path" : "/chapter-003",
 			"name" : "chapter-003",
 			"component" : CHAPTER003
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js